<template>
  <div>
    <el-button v-if="$hasPerm('tenant:activity_lottery:add_lottery')" class="newAdd" @click="openDialog"
      size="mini">添加奖券</el-button>
    <el-dialog title="奖券管理" :visible.sync="moveDialogVisible" width="40%" center @close="clear"
      :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="奖券名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" class="searchIpt" autocomplete="off" placeholder="请输入奖券名称"></el-input>
        </el-form-item>
        <el-form-item label="奖券内容" :label-width="formLabelWidth" prop="content">
          <el-select v-model="form.content" placeholder="奖券内容" clearable :style="{ width: '100%' }">
            <el-option v-for="(item, index) in PAYMENTS" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖券面值" :label-width="formLabelWidth" prop="faceValue">
          <el-input v-model="form.faceValue" class="searchIpt" autocomplete="off" placeholder="输入面值">
            <template slot="append">USDT</template>
          </el-input>
        </el-form-item>
        <el-form-item label="奖池" :label-width="formLabelWidth" prop="totalSize">
          <!-- <span>当前剩余 {{ remaining }}</span> -->
          <el-input v-model="form.totalSize" class="searchIpt" autocomplete="off" placeholder="输入张数">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="clear">关闭</el-button>
        <el-button v-if="$hasPerm('tenant:activity_lottery:add_lottery')" size="mini" type="primary"
          @click="add">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { PAYMENTS } from '../../constants'

export default {
  data() {
    return {
      PAYMENTS,
      remaining: 2,
      moveDialogVisible: false,
      detailInfo: null,
      isAct: false,
      form: {
        name: '',
        content: '',
        faceValue: '',
        totalSize: '',
        tenantId: -1,
      },

      formLabelWidth: '80px',
      rules: {
        name: [{ required: true, message: '请输入奖券名称', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入奖券内容', trigger: 'blur' },
        ],
        faceValue: [
          { required: true, message: '请输入奖券面值', trigger: 'blur' },
        ],
        totalSize: [{ required: true, message: '请输入奖池', trigger: 'blur' }],
      },

      typeOptions: [
        {
          label: '普通账户',
          value: 0,
        },
        {
          label: '量化账户',
          value: 1,
        },
        {
          label: '风险保证金账户',
          value: 2,
        },
      ],

      addTaskArr: 1,
    }
  },
  methods: {
    ...mapActions('activityLottery', [
      'addPartner',
      'getUserData',
      'addLottery',
    ]),

    handleAddTask() {
      this.addTaskArr++
    },
    handleDelTask() {
      this.addTaskArr == 0 ? (his.addTaskArr = 0) : this.addTaskArr--
    },
    openDialog() {
      this.moveDialogVisible = true
    },

    add() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.addLottery(this.form).then((res) => {
            if (res.code == 0) {
              this.$message.success('添加成功')
              this.$emit('refresh')
              this.clear()
            } else {
              this.$message.error('添加失败')
              this.clear()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    clearFiled() {
      this.$refs['form'].resetFields()
    },
    clear() {
      this.moveDialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style lang="less" src="@/styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;

  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }

  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;

    .ipt {
      width: 90%;
    }
  }
}

.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.langTab {
  cursor: pointer;
  margin-right: 20px;
  display: inline-block;
}

.task {
  border: 1px solid #000;
  padding: 12px;
}

.flex {
  display: flex;
  gap: 12px;
  align-items: center;
}

.addTask {}
</style>
